export const Conditions = (props: React.ComponentPropsWithoutRef<'svg'>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
      <path fill="currentColor" d="M6.398 11.6v-1.2h3.2v1.2h-3.2Zm-2.4-3V7.4h8v1.2h-8Zm-1.6-3V4.4h11.2v1.2h-11.2Z" />
    </svg>
  );
};
